class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.giftBoxes = new GiftBoxes();
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    const dataFreeGiftPupupEnableDisable = (this.dataset.freeGiftPupupEnableDisable === 'true');
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    if(dataFreeGiftPupupEnableDisable) {
      const freeGiftLocalStoragePercentStartPosition = document.querySelector('.gift-percent-remainder-container').getAttribute('data-percent-remainder');
      const freeGiftCircleOffsetLocalStorageStartPosition = document.querySelector('.remainder-percent-circle').getAttribute('data-offset');
      localStorage.setItem('freeGiftCircleOffsetLocalStorageStartPosition', freeGiftCircleOffsetLocalStorageStartPosition);
      localStorage.setItem('freeGiftPercentRemainder', freeGiftLocalStoragePercentStartPosition);
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '#cart-icon-bubble',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        if(app.customer) {
          parsedState.items && app.customer.updateCustomerUsedRewardPoints(parsedState.items);
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        for (const section of this.getSectionsToRender()) {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }

        const dataFreeGiftPupupEnableDisable = (this.dataset.freeGiftPupupEnableDisable === 'true');
        dataFreeGiftPupupEnableDisable && this.toggleFreeGiftPopup();
        this.giftBoxes._attachDynamicEvents();
        this.disableLoading();
      }).catch((error) => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        this.disableLoading();
        console.error("updateQuantity: fetch: error:", error);
      });
  }

  toggleFreeGiftPopup() {
    const freeGiftPopup = document.querySelector("[data-free-gift-popup]");
    const cartDrawerConatanerData = document.querySelector(".cart-drawer-content");
    const freeGift200Popup = document.querySelector(".free-gift-200-popup-container");
    let versionTwoFirstLevelGiftEligiblePrice = cartDrawerConatanerData.getAttribute('data-version-two-first-level-gift-eligible-price');
    let isVersionTwoFirstLevelFreeGiftPopupAppeared = localStorage.getItem("isVersionTwoFirstLevelFreeGiftPopupAppeared") ? true : false;
    let isFreeGift200PopupActivated = cartDrawerConatanerData.getAttribute('data-free-gift-200-popup-is-activated') === 'true' ? true : false;
    let firstLevelGiftEligiblePrice = cartDrawerConatanerData.getAttribute('data-first-level-gift-eligible-price');
    let secondLevelGiftEligiblePrice = cartDrawerConatanerData.getAttribute('data-second-level-gift-eligible-price');
    let cartTotalExcludingGiftCardsPrices = cartDrawerConatanerData.getAttribute('data-cart-total-exluding-gift-cards-prices');
    const isVersionTwoFirstLevelGiftEligible = +cartTotalExcludingGiftCardsPrices > +versionTwoFirstLevelGiftEligiblePrice;
    let isFirstLevelFreeGiftPopupWasAppeared = localStorage.getItem("isFirstLevelFreeGiftPopupWasAppeared") ? true : false;
    let isSecondLevelFreeGiftPopupWasAppeared = localStorage.getItem("isSecondLevelFreeGiftPopupWasAppeared") ? true : false;
    const isFirstLevelGiftEligible = +cartTotalExcludingGiftCardsPrices > +firstLevelGiftEligiblePrice;
    const isSecondLevelGiftEligible = +cartTotalExcludingGiftCardsPrices > +secondLevelGiftEligiblePrice;
    const freeGiftPricePercentRemainder = document.querySelector('.gift-percent-remainder-container');
    const freeGiftPercentEndPosition = freeGiftPricePercentRemainder.getAttribute('data-percent-remainder');
    const freeGiftPercentStartPosition = localStorage.getItem('freeGiftPercentRemainder');
    const freeGiftCircleOffsetStartPosition = localStorage.getItem('freeGiftCircleOffsetLocalStorageStartPosition')
    const freeGiftPricePercentRemainderNumber = Number(freeGiftPricePercentRemainder.getAttribute('data-percent-remainder'));

    const _addCircleAnimation = (selector, startPosition, endPosition) => {
      // if (endPosition >= 100) return;
      const widthAnimation = [
        { strokeDashoffset: startPosition },
        { strokeDashoffset: endPosition },
      ];
      const widthAnimationTiming = {
        duration: 300,
        iterations: 1,
      }
      selector.animate(widthAnimation, widthAnimationTiming);
    }

    const circle = document.querySelector('.remainder-percent-circle');
    const radius = circle.r.baseVal.value;
    const circumference = 2 * Math.PI * radius;

    const offset = circumference - freeGiftPricePercentRemainderNumber / 100 * circumference;
    circle.style.strokeDashoffset = offset;
    _addCircleAnimation(circle, freeGiftCircleOffsetStartPosition, offset);

    const isVersionTwoFirstLevelFreeGiftPopupAppearedMeantime = isVersionTwoFirstLevelGiftEligible && !isVersionTwoFirstLevelFreeGiftPopupAppeared;
    if (isFreeGift200PopupActivated) {
      if (isVersionTwoFirstLevelFreeGiftPopupAppearedMeantime) {
        localStorage.setItem("isVersionTwoFirstLevelFreeGiftPopupAppeared", true);
        freeGift200Popup.dispatchEvent(new CustomEvent('openFreeGift200Popup'));
      } else if (!isVersionTwoFirstLevelGiftEligible) {
        localStorage.removeItem("isVersionTwoFirstLevelFreeGiftPopupAppeared");
      }
    } else {
      const isFirstAndSecondLevelFreeGiftPopupsWasAppearedMeantime = isFirstLevelGiftEligible && !isFirstLevelFreeGiftPopupWasAppeared && isSecondLevelGiftEligible && !isSecondLevelFreeGiftPopupWasAppeared;
      if (isFirstAndSecondLevelFreeGiftPopupsWasAppearedMeantime) {
        localStorage.setItem("isFirstAndSecondLevelFreeGiftPopupsWasAppearedMeantime", true);
      }
      if (isFirstLevelGiftEligible && !isFirstLevelFreeGiftPopupWasAppeared) {
        localStorage.setItem("isFirstLevelFreeGiftPopupWasAppeared", true);
        localStorage.setItem("isFirstLevelFirstStep", true);
        freeGiftPopup.dispatchEvent(new CustomEvent('openFreeGiftPopup'));
      }
      if (!isFirstLevelGiftEligible) {
        localStorage.removeItem("isFirstLevelFreeGiftPopupWasAppeared");
        localStorage.removeItem("isFirstLevelFirstStep");
        localStorage.removeItem('isFirstLevelSecondStep');
        localStorage.removeItem('firstLevelFirstStepProductAddedToCart');
        localStorage.removeItem('firstLevelSecondStepProductAddedToCart');
      }
      if (isSecondLevelGiftEligible && !isSecondLevelFreeGiftPopupWasAppeared) {
        localStorage.setItem("isSecondLevelFreeGiftPopupWasAppeared", true);
        freeGiftPopup.dispatchEvent(new CustomEvent('openFreeGiftPopup'));
      }
      if (!isSecondLevelGiftEligible) {
        localStorage.removeItem("isSecondLevelFreeGiftPopupWasAppeared");
        localStorage.removeItem("isFirstAndSecondLevelFreeGiftPopupsWasAppearedMeantime");
        localStorage.removeItem('isSecondLevelMeanTime');
      }
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('cart-drawer-cart-items');
    mainCartItems.classList.add('cart-items-disabled');

    const cartDrawerItemElements = this.querySelectorAll(`#cart-drawer-item-${line} .loading-overlay`);
    const cartDrawerCheckoutOverlay = document.getElementById('checkout-loading-overlay');
    [...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));
    cartDrawerCheckoutOverlay.classList.remove('hidden');
    document.activeElement.blur();
  }

  disableLoading() {
    const mainCartItems = document.getElementById('cart-drawer-cart-items');
    mainCartItems.classList.remove('cart-items-disabled');
  }
}

customElements.define('cart-items', CartItems);
